module.exports = "/_next/static/images/Build@2x-31cc622632135a6635f471c163c69ab5.png";